module.exports = __webpack_public_path__ + "media/images/Misimo_Logotype_x2-5b7f623e80be9498d012f80048673509.svg";